import React, { Fragment } from 'react';
import PropTypes from 'prop-types';

import News from './News';
import Resolved from './Resolved';
import Solving from './Solving';
import Total from './Total';

import {
  Box,
  Grid,
  makeStyles
} from '@material-ui/core';

const useStyles = makeStyles((theme) => ({
  root: {
  }
}));

const Summary = ({ news, solving, resolveds, total }) => {

  const classes = useStyles();

  return (
    <Fragment>

      <Box mt={1} />
      <Grid
        container
        spacing={2}
      >
        <Grid
          item
          lg={3}
          sm={6}
          xl={3}
          xs={12}
        >
          <News count={news} total={total} />
        </Grid>
        <Grid
          item
          lg={3}
          sm={6}
          xl={3}
          xs={12}
        >
          <Solving count={solving} total={total} />
        </Grid>
        <Grid
          item
          lg={3}
          sm={6}
          xl={3}
          xs={12}
        >
          <Resolved count={resolveds} total={total} />
        </Grid>
        <Grid
          item
          lg={3}
          sm={6}
          xl={3}
          xs={12}
        >
          <Total count={resolveds} total={total} />
        </Grid>

      </Grid>

    </Fragment >
  );
};

Summary.propTypes = {
  className: PropTypes.string
};

export default Summary;
